(function(Array, String){

    if (!Array.prototype.find) {
        Array.prototype.find = function (predicate) {
            if (this === null) {
                throw new TypeError('Array.prototype.find called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return value;
                }
            }
            return undefined;
        };
    }
    if (!Array.prototype.includes) {
        Array.prototype.includes = function(searchElement /*, fromIndex*/) {
            'use strict';
            if (this == null) {
                throw new TypeError('Array.prototype.includes called on null or undefined');
            }

            var O = Object(this);
            var len = parseInt(O.length, 10) || 0;
            if (len === 0) {
                return false;
            }
            var n = parseInt(arguments[1], 10) || 0;
            var k;
            if (n >= 0) {
                k = n;
            } else {
                k = len + n;
                if (k < 0) {k = 0;}
            }
            var currentElement;
            while (k < len) {
                currentElement = O[k];
                if (searchElement === currentElement ||
                    (searchElement !== searchElement && currentElement !== currentElement)) { // NaN !== NaN
                    return true;
                }
                k++;
            }
            return false;
        };
    }

    if (!Array.prototype.some) {
        Array.prototype.some = function(fun/*, thisArg*/) {
            'use strict';

            if (this == null) {
                throw new TypeError('Array.prototype.some called on null or undefined');
            }

            if (typeof fun !== 'function') {
                throw new TypeError();
            }

            var t = Object(this);
            var len = t.length >>> 0;

            var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(thisArg, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    if(!Array.prototype.containsAny){
        Array.prototype.containsAny = function(array){
            'use strict';
            if(this == null){
                throw new TypeError('Array.prototype.containsAny called on null or undefined');
            }
            if (!Array.isArray(array)) {
                throw new TypeError();
            }

            var original = Object(this);
            /*TODO make this more efficient (i.e. stop when found)*/
            return array.map(function(el){
                return original.includes(el);
            }).reduce(function(prev,curr){
                return prev || curr;
            }, false);
        }
    }

    if(!String.prototype.equalsAny){
        String.prototype.equalsAny= function(array){
            'use strict';
            if(this == null){
                throw new TypeError('String.prototype.equalsAny called on null or undefined');
            }
            if (!Array.isArray(array)) {
                throw new TypeError();
            }

            var original = this;
            /*TODO make this more efficient (i.e. stop when found)*/
            return array.map(function(el){
                return (el === original);
            }).reduce(function(prev,curr){
                return prev || curr;
            }, false);
        }
    }

    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }
})(Array, String);
